import { Heading } from '@/components/common/Heading';
import type { Protocol } from '@/domain/Protocol';
import { getStorageUrl } from '@/lib/api';

interface ProtocolCardProps {
  protocol: Protocol;
}

export function ProtocolCard({ protocol }: ProtocolCardProps) {
  return (
    <div className="flex flex-col gap-2.5 lg:flex-row lg:items-start lg:gap-7.5">
      <div className="bg-muted flex size-37 shrink-0 items-center justify-center overflow-hidden rounded-2xl">
        {protocol.image_url ? (
          <img
            src={getStorageUrl(protocol.image_url)}
            alt={protocol.name}
            className="h-full w-full rounded-2xl object-cover"
          />
        ) : (
          <div className="text-muted-foreground text-sm">No image</div>
        )}
      </div>

      <div className="flex flex-col gap-3">
        <Heading as="h2" size="h3" className="text-left text-3xl">
          {protocol.name}
        </Heading>
        {protocol.type_explanation && (
          <p className="text-foreground leading-relaxed">
            {protocol.type_explanation}
          </p>
        )}
      </div>
    </div>
  );
}
